// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCeJZAu8cik_mHxDg_Ohu5q-ob4vxnk0vA",
  authDomain: "broadway-bingo.firebaseapp.com",
  projectId: "broadway-bingo",
  storageBucket: "broadway-bingo.firebasestorage.app",
  messagingSenderId: "587407227587",
  appId: "1:587407227587:web:223f23b879268d98ad0076",
  measurementId: "G-FPXE54346S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);